module.exports = __webpack_public_path__ + "static/media/telegram.37b44ca0.svg";